'use strict';
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import { addEvent } from './addEvent/addEvent';
import { smoothScrollbarInit } from './smoothScrollbar/smoothScrollbar';
import { smoothScrollbarTest } from './smoothScrollbar/smoothScrollbarTest';
import { lazyLoadImage } from './lazyLoading/lazyLoading';
import { fullSiteMenu } from './fullSiteMenu/fullSiteMenu';
import { fslightboxInit } from './fslightbox/fslightbox';
import noUiSlider from 'noUiSlider';

$.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener('touchstart', handle, { passive: true });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  if (smoothScrollbarTest()) window.smoothScroll = smoothScrollbarInit();
  new fullSiteMenu();
  pageScroled();
  fslightboxInit();

  nouisliderStart();
  znajdzMieszkanie();
});

addEvent(window, 'load', () => {
  lazyLoadImage(document.querySelectorAll('[data-images]'));
});

addEvent(window, 'resize', () => {});

addEvent(window, 'scroll', () => {});

function pageScroled() {
  const className = 'page-scrolled';
  const scrollBreakPoint = 10;
  if (window.smoothScroll) {
    window.smoothScroll.addListener(({ offset }) => {
      const scroll = offset.y;
      document.body.style.setProperty('--offsetY', scroll + 'px');
      if (scroll >= scrollBreakPoint) {
        document.body.classList.add(className);
      } else {
        document.body.classList.remove(className);
      }
    });
  } else {
    window.addEventListener('scroll', () => {
      const scroll = window.scrollY; // window.scrollY zastępuje $(window).scrollTop()
      document.body.style.setProperty('--offsetY', scroll + 'px');
      if (scroll >= scrollBreakPoint) {
        document.body.classList.add(className);
      } else {
        document.body.classList.remove(className);
      }
    });
  }
}

/*----- FORMULARZ SZUAJ MIESZKANIA -----*/
function znajdzMieszkanie() {
  let liveSearchForm = document.getElementById('live-search');
  if (!liveSearchForm) {
    return;
  }

  $(document).on('submit', $(liveSearchForm), function () {
    return false;
  });

  //get elements
  let metraz_od = document.getElementById('input-metraz-od');
  let metraz_do = document.getElementById('input-metraz-do');
  let ilosc_pokoi_od = document.getElementById('input-ilosc_pokoi-od');
  let ilosc_pokoi_do = document.getElementById('input-ilosc_pokoi-do');
  let pietro = document.getElementById('pietro');
  let status = document.getElementById('status');

  $(document).on('change', $(metraz_od), function () {
    updateMieszkaniaList();
  });
  $(document).on('change', $(metraz_do), function () {
    updateMieszkaniaList();
  });
  $(document).on('change', $(ilosc_pokoi_od), function () {
    updateMieszkaniaList();
  });
  $(document).on('change', $(ilosc_pokoi_do), function () {
    updateMieszkaniaList();
  });
  $(document).on('change', $(pietro), function () {
    updateMieszkaniaList();
    budynkiImgUpdate();
  });
  $(document).on('change', $(status), function () {
    updateMieszkaniaList();
  });

  budynkiImgSelect();
}

function budynkiImgSelect() {
  let budynkiImg = $('.szukaj-mieszkania-form .budynki-container .pietro');
  let pietro = document.getElementById('pietro');
  let img = document.getElementById('pietro-container-any');

  if (!pietro) {
    return;
  }

  $(budynkiImg).each(i => {
    $(budynkiImg[i]).on('click', function () {
      let thisBudynek = $(budynkiImg[i]).attr('data-pietro');
      $(pietro).val(thisBudynek).change();
      return false;
    });
  });

  $(img).on('click', function () {
    $(pietro).val('').change();
    return false;
  });
}

function budynkiImgUpdate() {
  let pietro = document.getElementById('pietro');
  let budynkiImg = $('.szukaj-mieszkania-form .budynki-container .pietro');

  if (!pietro) {
    return;
  }

  let budynekSelected = $(pietro).val();

  $(budynkiImg).each(i => {
    let thisBudynek = $(budynkiImg[i]).attr('data-pietro');

    if (thisBudynek == budynekSelected) {
      $(budynkiImg[i]).addClass('aktywny');
    } else {
      $(budynkiImg[i]).removeClass('aktywny');
    }
  });
}

function nouisliderStart() {
  let metrazLinearSlider = document.getElementById('metraz-slider');
  if (metrazLinearSlider) {
    let min = parseInt($(metrazLinearSlider).attr('data-min'));
    let max = parseInt($(metrazLinearSlider).attr('data-max'));
    let startMin = parseInt($(metrazLinearSlider).attr('data-start-min'));
    let startMax = parseInt($(metrazLinearSlider).attr('data-start-max'));
    let step = parseInt($(metrazLinearSlider).attr('data-step'));

    noUiSlider.create(metrazLinearSlider, {
      connect: true,
      tooltips: [true, true],
      behaviour: 'tap',
      start: [startMin, startMax],
      step: step,
      range: {
        min: [min],
        max: [max],
      },
    });

    let nodes = [
      document.getElementById('metraz-slider-od'), // 0
      document.getElementById('metraz-slider-do'), // 1
    ];

    let inputNodes = [
      document.getElementById('input-metraz-od'), // 0
      document.getElementById('input-metraz-do'), // 1
    ];

    nodes[0].innerHTML = startMin;
    nodes[1].innerHTML = startMax;

    metrazLinearSlider.noUiSlider.on(
      'update',
      function (values, handle, unencoded, isTap, positions) {
        nodes[handle].innerHTML = values[handle];
        inputNodes[handle].value = values[handle];
        updateMieszkaniaList();
      }
    );
  }

  let pokojeLinearSlider = document.getElementById('ilosc-pokoi-slider');
  if (pokojeLinearSlider) {
    let min = parseInt($(pokojeLinearSlider).attr('data-min'));
    let max = parseInt($(pokojeLinearSlider).attr('data-max'));
    let startMin = parseInt($(pokojeLinearSlider).attr('data-start-min'));
    let startMax = parseInt($(pokojeLinearSlider).attr('data-start-max'));
    let step = parseInt($(pokojeLinearSlider).attr('data-step'));

    noUiSlider.create(pokojeLinearSlider, {
      connect: true,
      tooltips: [true, true],
      behaviour: 'tap',
      start: [startMin, startMax],
      step: step,
      range: {
        min: [min],
        max: [max],
      },
      format: {
        from: function (value) {
          return parseInt(value);
        },
        to: function (value) {
          return parseInt(value);
        },
      },
    });

    let nodes = [
      document.getElementById('ilosc-pokoi-slider-od'), // 0
      document.getElementById('ilosc-pokoi-slider-do'), // 1
    ];

    let inputNodes = [
      document.getElementById('input-ilosc_pokoi-od'), // 0
      document.getElementById('input-ilosc_pokoi-do'), // 1
    ];

    nodes[0].innerHTML = startMin;
    nodes[1].innerHTML = startMax;

    pokojeLinearSlider.noUiSlider.on(
      'update',
      function (values, handle, unencoded, isTap, positions) {
        nodes[handle].innerHTML = values[handle];
        inputNodes[handle].value = values[handle];
        updateMieszkaniaList();
      }
    );
  }
}

function updateMieszkaniaList() {
  let metraz_od = document.getElementById('input-metraz-od');
  let metraz_do = document.getElementById('input-metraz-do');
  let ilosc_pokoi_od = document.getElementById('input-ilosc_pokoi-od');
  let ilosc_pokoi_do = document.getElementById('input-ilosc_pokoi-do');
  let pietro = document.getElementById('pietro');
  let status = document.getElementById('status');

  let filtr = {};
  filtr.metraz_od = parseFloat($(metraz_od).val());
  filtr.metraz_do = parseFloat($(metraz_do).val());
  filtr.ilosc_pokoi_od = parseInt($(ilosc_pokoi_od).val(), 10);
  filtr.ilosc_pokoi_do = parseInt($(ilosc_pokoi_do).val(), 10);
  filtr.pietro = $(pietro).val();
  filtr.status = $(status).val();

  let trElements = $('#spis-mieszkan tbody tr').not('.empty');

  $(trElements).each(i => {
    let thisMetraz = parseFloat($(trElements[i]).attr('data-metraz'));
    let thisIloscPokoi = parseInt(
      $(trElements[i]).attr('data-ilosc-pokoi'),
      10
    );
    let thisBudynek = $(trElements[i]).attr('data-pietro');
    let thisStatus = $(trElements[i]).attr('data-status');

    let show = true;

    if (filtr.status != '' && thisStatus != filtr.status) {
      show = false;
    }

    if (filtr.pietro != '' && thisBudynek != filtr.pietro) {
      show = false;
    }

    if (thisMetraz < filtr.metraz_od || thisMetraz > filtr.metraz_do) {
      show = false;
    }

    if (
      thisIloscPokoi < filtr.ilosc_pokoi_od ||
      thisIloscPokoi > filtr.ilosc_pokoi_do
    ) {
      show = false;
    }

    if (show) {
      $(trElements[i]).show().removeClass('tr-hidden');
    } else {
      $(trElements[i]).hide().addClass('tr-hidden');
    }
  });
}
